export default function(widget, defaults) {
  let preferences = Object.assign({}, defaults);

  for (let key in preferences) {
    if (preferences.hasOwnProperty(key)) {
      let customValue = widget.getAttribute(key);
      if (customValue != null) {
        preferences[key] = customValue;
      }
    }
  }

  return preferences;
}
